// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__zZB54","normalXl":"styles_normalXl__1A5lm","normalLg":"styles_normalLg__mVpk+","normalMd":"styles_normalMd__DB9D-","normalSm":"styles_normalSm__Kroel"};